import * as yup from 'yup'
import { MakeRequiredAndNullable } from './utils.js'

export const athenaClubCoManEomInventoryReconciliationLineSchema = yup
  .object({
    athenaItemNumber: yup.string().nullable().optional(),
    itemDescription: yup.string().nullable().optional(),
    itemType: yup.string().nullable().optional(),
    uom: yup.string().nullable().optional(),
    expectedOnHandQty: yup.string().nullable().optional(),
    manufacturerItemNumber: yup.string().nullable().optional(),
    availableOnHandQty: yup.string().nullable().optional(),
    scrappedQty: yup.string().nullable().optional(),
    wipQty: yup.string().nullable().optional(),
    vendorNotes: yup.string().nullable().optional(),
    varianceQty: yup.string().nullable().optional(),
    variancePercent: yup.string().nullable().optional(),
    acNotes: yup.string().nullable().optional(),
    acReview: yup.string().nullable().optional(),
  })
  .required()

export const athenaClubCoManEomInventoryReconciliationXlsxFileDataSchema = yup
  .object({
    vendorName: yup.string().nullable().optional(),
    inventoryLocation: yup.string().nullable().optional(),
    snapshotDate: yup.string().nullable().optional(),
    lineItems: yup.array().of(athenaClubCoManEomInventoryReconciliationLineSchema).required(),
  })
  .required()

export type AthenaClubCoManEomInventoryReconciliationXlsxFileData = yup.InferType<
  typeof athenaClubCoManEomInventoryReconciliationXlsxFileDataSchema
>
export type AthenaClubCoManEomInventoryReconciliationLineData = yup.InferType<
  typeof athenaClubCoManEomInventoryReconciliationLineSchema
>

type RequiredFileData =
  MakeRequiredAndNullable<AthenaClubCoManEomInventoryReconciliationXlsxFileData>

const lineItemMappings: MakeRequiredAndNullable<AthenaClubCoManEomInventoryReconciliationLineData> =
  {
    athenaItemNumber: '8f3433da-36f3-4484-865d-181456cd7a50',
    itemDescription: 'f8708762-4abe-4a16-b30c-c0f10039b0ec',
    itemType: '2fa1c369-47d9-4b46-87cb-d06cbc90fb06',
    uom: '97e03403-5d79-469b-93c5-b50efa5c70fb',
    expectedOnHandQty: '56568816-9623-494e-a21c-3e7652f48081',
    manufacturerItemNumber: 'aa0a86c5-890b-48d9-9862-ba305948f020',
    availableOnHandQty: '37b066df-269c-4238-801f-d975ab4458ad',
    scrappedQty: 'd2a8a884-d4b9-4473-bed5-ddecbc567c8d',
    wipQty: '76f87bf6-711a-413f-8a29-af8953f919b2',
    vendorNotes: '91d9106b-a150-467c-bd38-875e74aa0d9b',
    varianceQty: 'efb59a3e-5a0d-4b3f-9c70-61e7301c25f8',
    variancePercent: 'dfc5a707-bd7f-4b70-998e-d447fb69a367',
    acNotes: 'dbfcde15-017d-4f72-ae72-979dc9da962f',
    acReview: 'c3ccb146-b39d-45da-b026-70d665cec506',
  }

export const athenaClubCoManEomInventoryReconciliationXlsxFileMappings: RequiredFileData = {
  vendorName: '2639f63c-1317-4cf4-9bcc-a09b72de79b3',
  inventoryLocation: '9035c697-a03d-4379-926e-511f42b999f1',
  snapshotDate: '6723edff-0d84-4cca-abd1-283d1ba43780',
  lineItems: [lineItemMappings],
}
